<template>
    <error :code="500" :text="'Ошибка сервера.'">

    </error>
</template>

<script>
    import Error from "./Error";

    export default {
        name: "Error500",
        components: {Error}
    }

</script>

<style scoped>

</style>